module.exports = __webpack_public_path__ + "img/13.510b315b.jpg";